import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable, OnDestroy } from '@angular/core';
import { AgGridRequestService } from './ag-grid-request.service';
import { updateShipmentDiscrepancy } from '../models/shipmentMonitor.model';
import { HeaderService } from '../components/header/header.service';
import { Subject, takeUntil } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ShipmentMonitorService implements OnDestroy {
  private headers = new HttpHeaders({ 'Content-Type': 'application/json' });
  options = { headers: this.headers };
  private url = "api/shipmentMonitor" ;
  account;
  private destroy$ = new Subject<void>();

  constructor(private http: HttpClient,private agGridRequestService:AgGridRequestService,private headerService:HeaderService) {
    this.headerService.accountsSelected.pipe(takeUntil(this.destroy$)).subscribe((e) => (this.account = e[0]));
   }

  getCaseStatuses() {
    return this.http.get<string[]>(`/${this.url}/GetCaseStatuses`,this.options);
  }

  GetShipmentDiscrepancies(body, columnDefs, globalSearch?,sumColumnDefs?) {
    let filters = {};
    /*if (this.account) {  
      filters["Account"] = {
        filterType: "set",
        values: [this.account],
      };
    }*/
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columnDefs,
      globalSearch,
      filters,
      sumColumnDefs
    );
    return this.http.post(`/${this.url}/getShipmentDiscrepancies`, payload, {
      ...this.options,
    });
  }

  getShipmentDiscrepancy(ShipmentDiscrepancyId){
    return this.http.get(`${this.url}/getShipmentDiscrepancy?ShipmentDiscrepancyId=${ShipmentDiscrepancyId}`,this.options);
  }

  updateShipmentDiscrepancy(payload:updateShipmentDiscrepancy){
    return this.http.post(`/${this.url}/updateShipmentDiscrepancy`,payload,this.options);
  }
  
  exportClaims(body, columns, globalSearch) {
    const payload = this.agGridRequestService.transformAgGridRequest(
      body,
      columns,
      globalSearch
    );
    payload.loadAll= true;
    return this.http.post(`/${this.url}/GetShipmentDiscrepanciesExport`, payload, {
      headers: this.headers,
      observe: "response",
      responseType: "blob",
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
